<template>
  <v-data-table ref="table" class="purtrak-table" :headers="headers" :items="invoices"
      disable-pagination hide-default-footer calculate-widths
      fixed-header height="calc(100vh - 154px)"
      @dblclick:row="(e,item) => view(item.item)">
    <template v-slot:item.date="{value}">
      {{value | formatDate}}
    </template>
    <template v-slot:item.total="{value}">
      {{value | currency}}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'SettingsBillingHistory',
  data() {
    return {
      invoices: [],
      headers: [{ text: 'DATE', value: 'date', width:'30%',sortable:true},
                { text: 'NUMBER', value: 'number' ,width:'10%',sortable:false},
                { text: 'TOTAL', value: 'total' ,width:'30%',sortable:false,align:'right'},
                { text: 'STATUS', value: 'status' ,width:'30%',sortable:false,align:'center'}]
    }
  },
  async created() {
    const results = await this.$apiCall(`query SettingsBillingHistory {
                                          companyBillingHistory {
                                            invoiceId,date,number,total,status,url
                                          }
                                        }`);
    if (!results.error)
      this.invoices = results.data.companyBillingHistory;
  },
  methods: {
    load() {    // Do nothing other than prevent error when called from parent
    },
    view(invoice) {
      const win = window.open(invoice.url, '_blank');
      if (!win) {
        this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
        return;
      }
    }
  }
}
</script>